import { CAT_ED_REP_BASE, CAT_CR_REP_BASE } from './REPORTS';

/**
 * Key to use for storing the center in local Storage. The object stored in the Storage is:
 * {
 * }
 * @type {string} - The center key.
 */
export const WESOG_CENTER_STORE = 'wesog-center-store';

/**
 * Max length username size.
 * @type {number} - The max length username size.
 */
export const MAX_LENGTH_USERNAME = 15;

/**
 * Image not found.
 * @type {string} - Image not found.
 */
export const IMAGE_NOT_FOUND = './assets/img/image-not-found.png';

/**
 * @type {number} - Max scroll value from Y axial.
 */
export const MAX_SCROLL_Y_POSITION_20 = 20;

/**
 * @type {number} - Max scroll value from Y axial.
 */
export const INNER_WITH_400 = 400;

/**
 * @type {number} - Width value from X axial.
 */
export const INNER_WITH_500 = 500;

/**
 * @type {number} - Width value from X axial.
 */
export const INNER_WIDTH_600 = 600;

/**
 * @type {number} - Min width value from X axial.
 */
export const MIN_INNER_WIDTH_640 = 640;

/**
 * @type {number} - Width value from X axial.
 */
export const INNER_WIDTH_800 = 800;

/**
 * @type {number} - Max width value from X axial.
 */
export const MAX_INNER_WIDTH_950 = 950;

/**
 * @type {number} - Max width value from X axial.
 */
export const MAX_INNER_WIDTH_1080 = 1080;

/**
 * @type {number} - Width value from X axial.
 */
export const INNER_WIDTH_1100 = 1100;

/**
 * @type {number} - Width value from X axial.
 */
export const INNER_WIDTH_1200 = 1200;

/**
 * @type {number} - Width value from X axial.
 */
export const INNER_WIDTH_1450 = 1450;

/**
 * @type {number} - Max width value from X axial.
 */
export const MAX_INNER_WIDTH_1770 = 1770;

/**
 * @type {number} - Max width value from X axial.
 */
export const MAX_INNER_WIDTH_1970 = 1970;

/** @type {number} */
export const ZOOM_UP = 1.2;

/** @type {number} */
export const ZOOM_DOWN = 0.6;

/**
 * Current tab.
 * @type {{
 *    IMAGES: string,
 *    REPORTS: string,
 * }}
 */
export const CURRENT_TAB = {
    IMAGES: 'images',
    REPORTS: 'reports',
};

/**
 * @type {number} - Max page to fetch all the elements.
 */
export const /** @type {string} */ MAX_PAGE_FETCH_ALL_ELEMENTS = 2;

/**
 * @type {{
 *  ELEMENT: string,
 *  REPORT: string,
 *  LIGHTBOX: string,
 * }} - All cart element types.
 */
export const ADD_CART_ELEMENT_TYPE = {
    ELEMENT: 'add-element',
    REPORT: 'add-report',
    LIGHTBOX: 'add-lightbox',
};

/**
 * @type {number} - Max flex grow value.
 */
export const MAX_FLEX_GROW_VALUE = 200;

/**
 * @type {number} - Min fixed height upload image.
 */
export const MIN_FIXED_HEIGHT_UPLOAD_IMG = 500;

/**
 * @type {number} - Max number of upload images.
 */
export const MAX_NUMBER_OF_UPLOAD_IMAGES = 3;

/**
 * Filters component. This component is used to filter the search results.
 * @type {{
 *  CR: string,
 *  ED: string,
 *  CAT: string,
 *  CAT_ED: string,
 *  CAT_CR: string,
 *  CAT_ED_REP: string,
 *  CAT_CR_REP: string,
 *  CAT_REP: string
 *  PEO: string,
 *  PEO_NAME: string,
 *  COM_ED: string,
 *  COM_CR: string,
 *  COM_ORI: string,
 *  COM_ORI_VER: string,
 *  COM_ORI_HOR: string,
 *  COM_ORI_SQU: string,
 *  COM_ORI_PAN: string,
 *  COM_PEO: string,
 *  COM_PEO_WITHOUT: string,
 *  COM_PEO_IND: string,
 *  COM_PEO_PART: string,
 *  COM_PEO_GROUP: string,
 *  COM_FRAM: string,
 *  COM_FRAM_FIRST: string,
 *  COM_FRAM_MIDDLE: string,
 *  COM_FRAM_FULL: string,
 *  COM_FRAM_GEN: string,
 *  COM_FRAM_AIR: string,
 *  DAT: string,
 *  DAT_FROM: string,
 *  DAT_TO: string,
 *  GENE_CR: string,
 *  KEYWORDS: string,
 *  VID_ED_TYPE: string,
 *  PREMIUM_CR: string,
 *  ALL: string,
 *  VIDEOS: string,
 *  IMGS: string,
 * }} Filters Component.
 */
export const SUB_STRING_CODE = {
    CR: 'cr',
    ED: 'ed',
    CAT: 'cat',
    CAT_ED: 'catEd',
    CAT_CR: 'catCr',
    CAT_ED_REP: CAT_ED_REP_BASE,
    CAT_CR_REP: CAT_CR_REP_BASE,
    CAT_REP: 'Rep',
    PEO: 'peo',
    PEO_NAME: 'peoName',
    COM_ED: 'comEd',
    COM_CR: 'comCr',
    COM_ORI: 'Ori',
    COM_ORI_VER: 'OriVer',
    COM_ORI_HOR: 'OriHor',
    COM_ORI_SQU: 'OriSquare',
    COM_ORI_PAN: 'OriPanoramic',
    COM_PEO: 'Peo',
    COM_PEO_WITHOUT: 'PeoWithout',
    COM_PEO_IND: 'PeoInd',
    COM_PEO_PART: 'PeoPart',
    COM_PEO_GROUP: 'PeoGroup',
    COM_FRAM: 'Fram',
    COM_FRAM_FIRST: 'FramFirst',
    COM_FRAM_MIDDLE: 'FramMiddle',
    COM_FRAM_FULL: 'FramFull',
    COM_FRAM_GEN: 'FramGen',
    COM_FRAM_AIR: 'FramAir',
    DAT: 'dat',
    DAT_FROM: 'datFrom',
    DAT_TO: 'datTo',
    GENE_CR: 'geneCr',
    KEYWORDS: 'keywords',
    VID_ED_TYPE: 'vidAudEdType',
    PREMIUM_CR: 'premiumCr',
    ALL: 'All',
    VIDEOS: 'Videos',
    IMGS: 'Imgs',
};
